//DATA
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const PAGE_SAVED = 'PAGE_SAVED';
export const DELETE_PAGE = 'DELETE_PAGE';
export const RESET_PAGE = 'RESET_PAGE';

//UI
export const SAVING_PAGE = 'SAVING_PAGE';